import React from 'react';
import Button from '@prisjakt/ui-button';
import Chevron from 'mdi-react/ChevronRightIcon';
import T from '@prisjakt/ui-translate';
import * as S from './styles';

type Props = {
  query: string;
  selected: boolean;
  onClick: () => void;
};

export default ({ selected, onClick, query }: Props) => {
  return (
    <S.Item disabled={query.length < 2} selected={selected} onClick={onClick}>
      <S.OriginalQuery selected={selected} data-test="OriginalQuery">
        <span>
          <T domain="search">suggest.title-original</T> <i>{query}</i>
        </span>
        <Button
          disabled={query.length < 2}
          color="secondary"
          variant="icon"
          icon={<Chevron />}
        />
      </S.OriginalQuery>
    </S.Item>
  );
};
